import AcreditacionesCard from "./AcreditacionesCard";

const AcreditacionesGrid = ({
  selectedPeriodistas,
  setSelectedPeriodistas,
  periodistas,
  maxPreacreditados
}) => {
  return (
    <div className="acreditaciones-grid">
      {periodistas.map((per, i) => (
        <AcreditacionesCard
          periodista={per}
          selectedPeriodistas={selectedPeriodistas}
          setSelectedPeriodistas={setSelectedPeriodistas}
          maxPreacreditados={maxPreacreditados}
          key={i}
          isVerificado
        />
      ))}
    </div>
  );
};

export default AcreditacionesGrid;
